
import React, {  useState, useEffect } from "react";
import {  useSelector } from "react-redux";
import AccountLinks from "../AccountLinks";
import { languageLable } from "utilities/helpers";
import { makeStyles } from 'mui-styles';
import Paper from '@mui/material/Paper';
import swal from "sweetalert"
import Button from '@mui/material/Button';
import { IMAGE_BASE_URL } from "../../../../utilities/constants";
import { convert } from 'html-to-text';
import { PRODUCT_ACTION } from "utilities/constants";
import { useHistory } from "react-router-dom";

import Slide from '@mui/material/Slide';
import { Spin } from "antd";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import API from "api/api";


const api = new API();

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'contents',
    flexDirection: 'column',
    '& > *': {
      margin: theme.spacing(1),
      // width: theme.spacing(49),
      height: "auto",
      //  width:'100%'
    },
  },
  paper: {
    padding: 25,
  },
  appBar: {
    position: 'relative',
    background: '#396470'
  },
  title: {
    marginLeft: theme.spacing(1),
    flex: 1,
    color: "#fff",
    fontSize: 15
  },
  myContainer: {
    display: "flex",
    flexDirection: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  myDatePicker: {
    width: "85%",  // note: if I change this value to a fixed value (such as 500px) then the width is effected

  },
  datepicker: {
    width: "100%"
  },


}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


export default function ComboScheme() {
  const history = useHistory();
  const state1 = useSelector(state => state)
  const { selectedLanguageData } = state1.app;

  const classes = useStyles();

  const showSchemeList = () => {
    localStorage.removeItem('mainProducts');
      localStorage.removeItem('focProducts');
      localStorage.removeItem('balanceMainQty');
      localStorage.removeItem('balanceFOCQty');
    try {
      const handleCheckboxChange = (Id) => {
        setComboSchemeData((prevRows) =>
          prevRows.map((row) =>
            row.Id === Id ? { ...row, IsDelete: !row.IsDelete } : { ...row, IsDelete: false }
          )
        );
    
        const row = comboSchemeData.find(r => r.Id === Id);
        // console.log(`Row ${Id} checked: ${!row.IsDelete}, disabled: ${row.IsDelete}`);
      };

      return (

        <div className={classes.root}>

          {comboSchemeData.map((item, index) => {          
           var date = item.EndDate;
           var date1 = date.split('T')[0];
           let yy = date1.split('-')[0];
           let mm = date1.split('-')[1];
           let dd = date1.split('-')[2];
            // if (Startdate <= finalDate && Enddate >= finalDate) {
              return (
                  <Paper elevation={2} className={classes.paper}  >
                    
                  <div >
                    <img
                      src={`${IMAGE_BASE_URL}${`/Media/GetMediaById?id=`}${item.BannerImage}&h=650&w=1516`}
                    />
                    <div class="row" style={{ maxWidth: "100%" }} >
                      <div className="col-sm-5" style={{ width: "100%" }}>
                      <strong>{languageLable(selectedLanguageData, "Scheme: ")}</strong>
                      {languageLable(selectedLanguageData, item.Description)}
                      </div>
                    </div>
                    <div class="row" style={{ maxWidth: "100%" }} >
                    <div className="col-sm-5" style={{ width: "100%" }}>
                      <strong>{languageLable(selectedLanguageData, "Scheme Valid Till Date: ")}</strong>
                      {dd}.{mm}.{yy}
                      </div>
                    </div>
                    <br/>

                    <div class="row" style={{ maxWidth: "100%" }} >
                        <div className="ps-checkbox col-sm-8" style={{ width: "50%", justifyContent: 'start', display: 'flex' }}>
                       
                         <input
                            className="form-control"
                            type="checkbox"
                            id={item.Id}
                            checked={item.IsDelete}
                            onChange={() => handleCheckboxChange(item.Id)}
                            // onClick={handleCheckbos()}
                          />
                          <label htmlFor={item.Id}>
                          {languageLable(selectedLanguageData, "* I Agree to the")} 
                          </label>
                          <span
                            onClick={() => showTermsAndCondition(item)}
                            className="text-primary ms-2"
                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                          >
                            {languageLable(selectedLanguageData, "Terms & Conditions")}
                          </span>   
                      </div>   
                      <div className="pay-button-container col-sm-4" style={{ width: "50%", justifyContent: 'end', display: 'flex' }}>
                            <Button disabled={!item.IsDelete} variant="contained" onClick={() => handleProceedButton(item)} 
                            style={{ borderRadius: 20, width: 160, height: 40, textAlign: 'center', background: item.IsDelete ? '#39C4DB' : '#f5f5f5', color: item.IsDelete ? '#FFF' : '#d9d9d9', padding: "6px 12px" }} >
                            <div style={{ fontSize: 18 }}> {languageLable(selectedLanguageData, "Proceed")} </div>
                          </Button>
                      </div>  
                  </div>
                  </div>
                         
                </Paper>
              )
          })}

        </div>
      )
    } catch (e) {
      console.error("Error...in show Scheme List..:", e)
    }
  }

  // const handleCheckbos = async () => {
  //   setIsDisabled(!isDisabled)
  // }

  const showTermsAndCondition = (item) => {
    swal({
      title: languageLable(selectedLanguageData, "Terms & Conditions"),
      content: "text",
      text: convert(item.TermsAndCondition),
      //placeholder: "Enter your loyalty points",
      button: {
        text: languageLable(selectedLanguageData, "Close"),
        closeModal: true,
      }
    })
      .then((ok) => {
      });
  }

  const handleProceedButton = async (item) => {
    const container = document.createElement("div");
  
    // Create input
    const input = document.createElement("input");
    input.className = " ms-2"
    input.type = "number";
    input.min = "0";
    input.placeholder = "0";
    input.style.width = "80px";
    input.style.height = "30px";
    input.style.fontSize = "18px";
    input.style.textAlign = "center";
    // input.style.marginLeft = "10px";
    input.style.border = "1px solid #ccc";
    input.style.borderRadius = "6px";

    // Create labels
    const label = document.createElement("label");
    label.innerText = languageLable(selectedLanguageData,  "Number of scheme:");
    label.style.fontSize = "18px";
    label.style.fontWeight = "500";
    label.style.marginBottom = "12px";

    const qty1 = document.createElement("div");
    const qty2 = document.createElement("div");  
    qty1.innerText = languageLable(selectedLanguageData,  "Primary Quantity:") + ` 0`;
    qty2.innerText = languageLable(selectedLanguageData,  "Scheme Quantity:") + ` 0`;
    qty1.style.marginTop = "20px";
    qty2.style.marginTop = "8px";
    qty1.style.fontSize = qty2.style.fontSize = "17px";

    input.addEventListener("input", () => {
      const schemes = parseInt(input.value || "0");
      qty1.innerText =  languageLable(selectedLanguageData,  "Primary Quantity:") + ` ${schemes * item.OriginalQuantity}`; // Example logic
      qty2.innerText = languageLable(selectedLanguageData,  "Scheme Quantity:") + ` ${schemes * item.FOCQuantity}`;  // Example logic
    });

     // Assemble
     const topRow = document.createElement("div");
    //  topRow.style.display = "flex";
    //  topRow.style.alignItems = "center";
    //  topRow.style.marginBottom = "16px";
     topRow.appendChild(label);
     topRow.appendChild(input);

     container.appendChild(topRow);
       container.appendChild(qty1);
    container.appendChild(qty2);

    swal({
      title: languageLable(selectedLanguageData, "Enter number of schemes"),
      content: container,
      //placeholder: "Enter your loyalty points",
      button: {
        text: languageLable(selectedLanguageData, "Proceed"),
        closeModal: true,
      },
      closeModal: true
    })
      .then((ok) => {
        if (ok) {
          const num = parseInt(input.value || "0");
          if (num > 0) {
            swal.close(); 
            history.push(
                    `/product-details/${item.Id}/ComboScheme?action=${PRODUCT_ACTION.COMBOSCHEME}&foc=${item.FOCQuantity}&original=${item.OriginalQuantity}&maina=${item.MainAssortmentNumber}&foca=${item.FOCAssortmentNumber}&totalscheme=${num}`
                  );
              //http://localhost:3000/product-details//Grouped?action=Replace&serialno=120916176&InvoiceNumber=8362400084
          } else {
            swal("", "Please enter Number of scheme", "error");
          }
        }
        else {
          
        }
      });
  }

  let businessid = localStorage.getItem('businessId');
    const [loading, setLoading] = useState(false);  
    const [comboSchemeData, setComboSchemeData] = useState([])


  
  const handleGetComboScheme = async () => {
    setLoading(true);

    try {
      api
      .get(
        `GetComboSchemes?businessid=${businessid}`
      )
      .then((response) => {
        if (response.StatusCode === 200 && response.Result) {
          if (response.Result !== null) {
            setComboSchemeData(response.Result)
          }
          setLoading(false);
        }
      });
    } catch (e) {
      setLoading(false)
      console.error("Error..in handleGetComboScheme", e)
    }
  }

  useEffect(() => {
    handleGetComboScheme();
  }, [])
   
    return (

    <section className="ps-my-account ps-page--account">
      <div className="ps-container">
        <div className="row">

          <AccountLinks page="combo-scheme" />
          <div className="col-lg-8">
          <div className="ps-page__content">

                         
              {loading === true ?
                (
                  <div className="ps-section--account-setting">
                  <div class="container-fluid ">

                  <div className="ps-section__header">
                            <h3>
                              {languageLable(selectedLanguageData, "Scheme")}
                            </h3>
                          </div>

                      <div style={{ width: '820px', height: "300px", position: 'static', display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Spin style={{ zIndex: 9999, display: 'inline-block', justifyContent: "center", alignSelf: "initial", alignItem: 'center', position: "absolute" }} />
                      </div>

                    </div>
                  </div>
                ) : (
                  comboSchemeData.length > 0 ?
                  <div className="ps-section--account-setting">
                  <div class="container-fluid ">

                         <div className="ps-section__header">
                            <h3>
                              {languageLable(selectedLanguageData, "Scheme")}
                            </h3>
                          </div>
                          </div>
                        {/* <div class="scrollerScheme" > */}
                          {showSchemeList()}
                        {/* </div> */}

                      </div>
                                          
                    : <div style={{ marginTop: 10 }} />
                )
              }
              

              {/* {showDialog()} */}
                          </div>
                          
          </div>
        </div>
      </div>
    </section >

  )
}
